const normalizeId = (value) => String(value || '').trim().toLowerCase();

export const getAgentPropertyIds = (agent) => {
  if (!agent) return [];
  return [agent.id, agent.adminId].filter(Boolean).map(normalizeId);
};

export const getAgentProperties = (properties, agent) => {
  if (!agent || !Array.isArray(properties)) return [];

  const agentIds = getAgentPropertyIds(agent);
  if (agentIds.length === 0) return [];

  return properties.filter((property) => {
    if (!property?.agentId) return false;
    return agentIds.includes(normalizeId(property.agentId));
  });
};

export const getAgentPropertyCount = (properties, agent) =>
  getAgentProperties(properties, agent).length;
